import React, { useEffect, useState } from 'react'
import { columnDefs } from './constants'
import { TableCell, TableRow } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const GenerateVchRowData = ({ data = [] }) => {
    const [tableData, setTableData] = useState([])
    const [filterValues, setFilterValues] = useState({});

    useEffect(() => {
        setTableData(data)
        setFilterValues({})
    }, [data])
    useEffect(() => {
        const filteredDataTemp = data.filter((item) => {
            return columnDefs?.every((column) => {
                const filterValue = filterValues[column.field]; // Can be 0 or any other value
                const value = item[column.field]; // The value in the row
                if (filterValue !== undefined && filterValue !== "") {
                    return value != null && value?.toString()?.toLowerCase()?.includes(filterValue?.toString()?.toLowerCase());
                }
                return true;
            });
        });
        // setTableData(filteredDataTemp);
        setTableData(filteredDataTemp.length > 0 ? filteredDataTemp : []);
    }, [filterValues]);
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    return (
        <>
            <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                {columnDefs.map((col, index) => (
                    col.showfilter ? (
                        <TableCell key={`FTH-${index}`}>
                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                <input
                                    id={`Contains-${index}`}
                                    className="field"
                                    // value={searchData[col.field]}
                                    name="cancelSearchInput"
                                    style={{ width: '100%' }}
                                    placeholder="Contains"
                                    onChange={(e) => handleChangeContain(e, col.field)}
                                // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                                />
                                <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                            </div>
                        </TableCell>
                    ) : <TableCell key={`FTH-${index}`}></TableCell>
                ))}
            </TableRow>
            {tableData.length > 0 ?
                <>
                    {tableData.map((val) => (<TableRow>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                            {val?.SN}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.LRNO}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.LRDate}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.PartyName}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.GSTN}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.PaymentType}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.TransactionType}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.GSTInv}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                            {val?.GSTDate}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                            {val?.GSTAmt}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                            {val?.Outstanding}
                        </TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right' }}>
                            {val?.NetAmount}
                        </TableCell>
                    </TableRow>
                    ))}
                </>
                :

                <TableRow>
                    <TableCell colSpan={columnDefs?.length}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                            }}
                        >
                            <span>No Results Found For The Selected Filters.</span>
                        </div>
                    </TableCell>
                </TableRow>
            }
        </>
    )
}

export default GenerateVchRowData